import { NavItem } from 'reactstrap';
import styled from 'styled-components';

export const SelectedLangOption = styled.label`
  color: white;
  font-weight: bold;
`;

export const LangOption = styled.label`
  a {
    color: white;
    text-decoration: underline;

    :hover {
      text-decoration: none;
    }
  }
`;

export const LanguageToggleNavItem = styled(NavItem).attrs({})`
  color: white;

  & > :not(:last-child):after {
    content: '|';
    margin: 0px 4px;
    color: white;
  }
`;



// WEBPACK FOOTER //
// ./src/components/common/Navigation/LanguageToggle/LanguageToggle.style.js